module.exports = __webpack_public_path__ + "img/send.039b1f94.png";